export const containsValues = (array: any[] | undefined | null): boolean => {
    return array !== undefined && array !== null && array.length !== 0
}

export const contains = <T>(array: T[], value: T) => {
    return array.filter(item => item === value).length === 1
}